import { useState, useEffect } from "react";
import { FaDiscord } from "react-icons/fa";
import logo from "../assets/logo.jpg";

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${scrolled ? 'bg-black/20 backdrop-blur-md py-2 shadow-md' : 'bg-black py-4 shadow-lg'} border-b border-orange-500`}>
            <div className="max-w-7xl mx-auto px-4 flex items-center justify-between transition-all duration-500">
                <div className="flex items-center gap-3 transition-all duration-500">
                    <img
                        src={logo}
                        alt="RPČKO logo"
                        className={`transition-all duration-500 ${scrolled ? 'w-8 h-8' : 'w-10 h-10'}`}
                    />
                    <h1 className={`transition-all duration-500 font-bold tracking-widest ${scrolled ? 'text-xl' : 'text-2xl'} text-orange-500`}>
                        RPČKO.EU
                    </h1>
                </div>

                <a
                    href="https://discord.gg/VbKJks6cYG"
                    className="flex items-center gap-2 px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-md transition-all duration-300"
                >
                    <FaDiscord className="text-lg" />
                    Připojit se
                </a>
            </div>
        </nav>
    );
}
